import { JobManagementApiService } from '@gtpl/shared-services/job-management-api';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AssetActionControlController } from './asset-action-control.controller';
import { AssetsActionControl } from './asset-action-control.entity';
import { AssetActionControlRepository } from './asset-action-control.repository';
import { AssetActionControlService } from './asset-action-control.service';



@Module({
  imports: [
    TypeOrmModule.forFeature([AssetActionControlRepository]),
  ],
  controllers: [AssetActionControlController],
  providers: [AssetActionControlService, ApplicationExceptionHandler, JobManagementApiService,LogsService],
  exports:[AssetActionControlService]
})
export class AssetsActionControlModule { }
